import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Import translation hook
import '../../style/AddAllergyPage.css'; // Import the CSS file

const AddAllergyPage = () => {
    const { id } = useParams(); // Get pet ID from URL
    const navigate = useNavigate(); // For redirection
    const { t } = useTranslation(); // Translation function
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Backend URL
    const [newAllergy, setNewAllergy] = useState({
        name: '',
        diagnosisDate: '',
        notes: '',
    });
    const [error, setError] = useState(null);

    const handleCreateAllergy = async () => {
        try {
            const storedUser = JSON.parse(localStorage.getItem('user')); // Retrieve user data from localStorage
            const token = storedUser?.token;

            if (!token) {
                throw new Error(t('general.noAuthToken')); // Use translation for error
            }

            // Create the allergy
            const allergyResponse = await fetch(`${baseUrl}/api/pets/${id}/conditions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`, // Include token in Authorization header
                },
                body: JSON.stringify({
                    name: newAllergy.name,
                    type: 'allergy',
                    diagnosisDate: newAllergy.diagnosisDate,
                    notes: newAllergy.notes,
                }),
            });

            if (!allergyResponse.ok) {
                throw new Error(t('allergy.createFailed')); // Use translation for error
            }

            const addedAllergy = await allergyResponse.json(); // Expect the backend to return only the newly created allergy
            console.log(addedAllergy); // Debug log

            if (!addedAllergy._id) {
                throw new Error(t('allergy.missingAllergyId')); // Use translation for error
            }

            navigate(`/pet/${id}/conditions/${addedAllergy._id}`); // Redirect to the Allergy Page
        } catch (error) {
            setError(error.message);
            console.error(error);
        }
    };

    return (
        <div className="add-allergy-form bg-dafauna-background rounded-xl shadow-md p-8">
            <h3 className="text-dafauna-darkText text-2xl font-bold text-center mb-4">{t('allergy.title')}</h3>
            {error && <p className="error-message text-red-500 text-center">{error}</p>}
            <div className="form-group">
                <label htmlFor="allergyName" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.allergyName')}
                </label>
                <input
                    type="text"
                    id="allergyName"
                    placeholder={t('condition.allergyNamePlaceholder')}
                    value={newAllergy.name}
                    onChange={(e) => setNewAllergy({ ...newAllergy, name: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="diagnosisDate" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.diagnosisDate')}
                </label>
                <input
                    type="date"
                    id="diagnosisDate"
                    placeholder={t('condition.diagnosisDatePlaceholder')}
                    value={newAllergy.diagnosisDate}
                    onChange={(e) => setNewAllergy({ ...newAllergy, diagnosisDate: e.target.value })}
                    required
                    className="form-input border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <div className="form-group">
                <label htmlFor="notes" className="block text-dafauna-darkText font-medium mb-2">
                    {t('condition.notes')}
                </label>
                <textarea
                    id="notes"
                    placeholder={t('condition.notesPlaceholder')}
                    value={newAllergy.notes}
                    onChange={(e) => setNewAllergy({ ...newAllergy, notes: e.target.value })}
                    className="form-textarea border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:border-dafauna-primary"
                />
            </div>
            <button
                onClick={handleCreateAllergy}
                className="create-allergy-page-btn w-full bg-dafauna-primary text-white rounded-md px-4 py-2 hover:bg-dafauna-primaryLight disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
                {t('allergy.createButton')}
            </button>
        </div>
    );
};

export default AddAllergyPage;